// extracted by mini-css-extract-plugin
export default {"item":"styles_item__-3XBw","label":"styles_label__RXz2a","value":"styles_value__lTtDR","labelText":"styles_labelText__KBhM7"};